"use strict";
/**
 * @file Created on 28.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomas Leity
 */


var NotificationDoc =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(NotificationDoc, _DomainObject_1$Domai);

  function NotificationDoc() {
    _classCallCheck(this, NotificationDoc);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotificationDoc).apply(this, arguments));
  }

  _createClass(NotificationDoc, [{
    key: "fixCopy",

    /**
     * @inheritDoc
     */
    value: function fixCopy(copy) {
      return _get(_getPrototypeOf(NotificationDoc.prototype), "fixCopy", this).call(this, copy);
    }
  }]);

  return NotificationDoc;
}(DomainObject_1.DomainObject);

exports.NotificationDoc = NotificationDoc;